export const validator = {
  validate: (formData) => {
    const errors = {};
    const warnings = {};

    const {
      engineerDetails = {},
      craftOrCaravanDetails = {},
      lpgLockerAndSupply = {},
      pipeworkAndTightness = {},
      appliances = {},
      verdictAndSignatures = {}
    } = formData;

    if (!engineerDetails.engineerName?.trim()) {
      errors['engineerDetails.engineerName'] = 'Engineer name is required';
    }
    if (!engineerDetails.gasSafeNumber?.trim()) {
      errors['engineerDetails.gasSafeNumber'] = 'Gas Safe registration number is required';
    }
    if (!craftOrCaravanDetails.craftNameOrReg?.trim()) {
      errors['craftOrCaravanDetails.craftNameOrReg'] = 'Vessel name or Registration / CRiS ID is required';
    }
    if (!craftOrCaravanDetails.ownerName?.trim()) {
      errors['craftOrCaravanDetails.ownerName'] = 'Owner / Duty holder name is required';
    }

    // Safety Tightness check
    const drop = Number(pipeworkAndTightness.tightnessDropRecordedMbar) || 0;
    if (drop > 0) {
      errors['pipeworkAndTightness.tightnessDropRecordedMbar'] = 'Marine/Caravan standard requires 0.0 mbar drop over 2 minutes.';
    }

    if (appliances.cookerFfd?.includes('Failed')) {
      errors['appliances.cookerFfd'] = 'Cooker failed FFD test. All LPG marine/caravan appliances must feature 100% flame supervision.';
    }

    if (lpgLockerAndSupply.gasLockerVapourTight?.includes('No')) {
      errors['lpgLockerAndSupply.gasLockerVapourTight'] = 'LPG locker must be vapour-tight to accommodation area under BSS and BS EN ISO 10239.';
    }

    if (!verdictAndSignatures.engineerSignature) {
      errors['verdictAndSignatures.engineerSignature'] = 'Gas Safe engineer signature is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
      warnings
    };
  }
};

export default validator;
